import { Box, Typography } from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useProviderDetails } from '../ProviderDetails/ProviderDetails.provider'

interface RequireAdminProps {
  children: ReactNode
}

export const RequireAdmin = ({ children }: RequireAdminProps) => {
  const { myProviderDetails } = useProviderDetails()
  const location = useLocation()
  const [checkComplete, setCheckComplete] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    // Only run the check if we have provider details
    if (myProviderDetails && myProviderDetails.accessRoles) {
      const hasAdminRole = myProviderDetails.accessRoles.some(
        (role) => role.description && role.description.includes('Admin')
      )

      // Set both states in one effect to avoid multiple renders
      setIsAdmin(hasAdminRole)
      setCheckComplete(true)
    }
  }, [myProviderDetails])

  if (!checkComplete) {
    return (
      <Box
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}
      >
        <Typography variant='h4'>Checking permissions...</Typography>
      </Box>
    )
  }

  if (!isAdmin) {
    console.log('User is not admin, redirecting to home')
    return <Navigate to='/home' state={{ from: location }} replace />
  }

  return <>{children}</>
}
